<template>
  <div class="page">
    <p class="p1">查询订单</p>
    <div class="query-class">
      <nut-textinput placeholder="请输入ICCID号" maxlength="20" v-model.trim="iccid"/>
      <nut-button block @click="query">查询订单</nut-button>
      <div class="div_tips">
        <span>温馨提示：</span>
          <!-- 因公司春节放假，2月03日至2月17日提交的开票申请，将统一在2月18日上班后陆续安排开票，已知悉请点击下方【下一步】继续填写资料，造成不便，敬请谅解，谢谢！ -->
          发票申请成功后，我司将在7个工作日左右统一处理（节假日将延长），详情可咨询【在线客服】，已知悉请点击下方【下一步】继续填写资料，谢谢！
      </div>
    </div>
    <div v-if="dataShow" style="padding-bottom:85px">
      <p class="kong"></p>
      <div class="orderList">
        <div v-if="dataList.length">
          <p>可开票订单：( 可多选数据 )</p>

          <div v-if="zhanshi">
            <nut-checkbox v-model="item.xz" @change="singleChoice()" v-for="(item,index) in dataList" :key="index" size="small" v-show="index<2">
              <span class="order-class">{{item.productName}}</span>
              <span class="money-class">{{item.price}}元</span>
            </nut-checkbox>
          </div>

          <div v-if="!zhanshi">
            <nut-checkbox v-model="item.xz" @change="singleChoice()" v-for="(item,index) in dataList" :key="index" size="small">
              <span class="order-class">{{item.productName}}</span>
              <span class="money-class">{{item.price}}元</span>
            </nut-checkbox>
          </div>
          <p class="zs-class" @click="showMore" v-if="dataList.length >2">{{zsgdtext = zhanshi == true ?"点击展示更多":"点击收起"}}</p>
        </div>
      </div>
      <p class="kong"></p>
      <div class="d_phone" v-if="dataList.length">
        <nut-textinput placeholder="请输入充值使用的手机号码" v-model="phone" type="tel" maxlength="11" :clear-btn ="false"/>
        <nut-textinput placeholder="请输入验证码" v-model="phonecode" type="tel" maxlength="4" :clear-btn ="false"/>
        <div class="input-code">
          <span v-show="show" @click="getCode" class="opt-a">获取验证码</span>
          <span v-show="!show" class="count opt-a">{{count}}s后可重发</span>
        </div>
      </div>
      <div class="footer" v-if="dataList.length">
        <nut-button @click="nextStep()">下一步</nut-button>
      </div>
    </div>

  </div>
</template>
<script>
import { wx_invoiceList } from "@/api/api.js"; 
import { wx_invoiceSendInvoiceSms } from "@/api/api.js";
import { wx_invoiceCheckPhone } from "@/api/api.js";
export default {
  data() {
    return {
      zhanshi:true,
      zsgdtext:"",

      dataShow:false,
      iccid:undefined,
      code:undefined,
      channel:undefined,

      dataList:[],
      bkdataList:[],
      selectList:[],
      phone:"",
      phonecode:"",
      totalMoney:0,

      show: true,
      count: "",
      timer: null,

    };
  },
  computed: {},
  methods: {
    query(){
      this.zhanshi = true;
      this.dataList = [];
      this.bkdataList = [];
      this.dataShow = false;
      let params={
        iccid: this.iccid
      }
      wx_invoiceList(params).then(res=>{
        if(res.data.code == 200){
          localStorage.setItem("iccid",this.iccid);
          this.dataList = res.data.data.canInvoice;

          this.bkdataList = res.data.data.noInvoice;
          if(res.data.data.canInvoice.length && res.data.data.noInvoice.length){
            this.dataShow = true;
            this.dataList = res.data.data.canInvoice;
            this.bkdataList = res.data.data.noInvoice;
          }else if(res.data.data.canInvoice.length && !res.data.data.noInvoice.length){
            this.dataShow = true;
            this.dataList = res.data.data.canInvoice;
          }else if(!res.data.data.canInvoice.length && res.data.data.noInvoice.length){
            this.dataShow = true;
            this.bkdataList = res.data.data.noInvoice;
          }else{
            this.dataShow = false;
            this.$toast.warn('暂无可开票订单');
          }
        }else{
          this.dataShow = false;
          this.$toast.warn(res.data.message);
        }
      })
    },
    showMore(){
      this.zhanshi = !this.zhanshi
    },
    // 选中开票订单
    singleChoice(){
      let newArr = this.dataList.filter(item => {
        return item.xz == true
      })
      this.selectList = newArr.map(item=>{
        return item.orderNum
      })
      this.totalMoney = newArr.map(item=>{
        return item.price
      })
    },
    // 获取验证码
    getCode(){
      let params={
        phone: this.phone
      }
      wx_invoiceSendInvoiceSms(params).then(res=>{
        if(res.data.code == 200){
          const TIME_COUNT = 60;
          if (!this.timer) {
            this.count = TIME_COUNT;
            this.show = false;
            this.timer = setInterval(() => {
              if (this.count > 0 && this.count <= TIME_COUNT) {
                this.count--;
              } else {
                this.show = true;
                clearInterval(this.timer);
                this.timer = null;
              }
            }, 1000);
          }
        }
      })
    },
    // 下一步
    nextStep(){
      if(this.selectList.length === 0){
        this.$toast.warn("请选择发票订单");
        return;
      }
      let params = {
        iccid: this.iccid,
        phone: this.phone,
        verCode: this.phonecode
      }
      wx_invoiceCheckPhone(params).then(res=>{
        if(res.data.code == 200){
          this.$router.push({
            name: "invoiceXx",
            params: {
              iccid:this.iccid,
              totalMoney:this.totalMoney,
              orderNums:this.selectList,
              code:this.code,
              channel:this.channel
            }
          });
        }else{
          this.$toast.warn(res.data.message);
        }
      })
    },
    // 初始化获取数据
    initData(){
      this.iccid = localStorage.getItem("iccid");
      this.code = this.getUrlParam("code") || localStorage.getItem("code");
      this.channel = this.getUrlParam('channel') || localStorage.getItem("channel");
      localStorage.setItem("code",this.code);
      localStorage.setItem("channel",this.channel);
    },
    
    // 获取code
    getUrlParam(name) {
      const href = window.location.href;
      let reg = new RegExp( '[?&]' + name + '=([^&]*)', 'i' );
      let string = reg.exec(href);
      return string ? string[1] : null;
    },
  },
  created() {
    
    this.initData()
  },
  mounted() {
    window.document.title = "查询订单";
  },
};
</script>
<style scoped lang="less">
  .page{
    .p1{
      text-align: center;
      height: 40px;
      line-height: 40px;
      background: #F94040;
      color: #fff;
      font-size: 18px;
      position: relative;
    }
    .zs-class{
      width: 100%;
      height: 25px;
      line-height: 25px;
      text-align: center;
      margin-top: 10px;
    }
    .query-class{
      margin-top: 25px;
        /deep/ .nut-textinput{
        margin: 0 auto;
        width: 80%;
        border: 2px solid #F94040;
        height: 45px;
        line-height: 41px;
        border-radius: 5px;
        input{
          border: 1px solid #fff;
          font-size: 15px;
        }
      }
      /deep/ .nut-button.block {
        width: 80%;
        margin: 25px auto;
        display: block;
        height: 45px;
        font-size: 16px;
        border-radius: 5px;
        background: #f94040;
      }
    }
    .kong{
      width: 100%;
      height: 15px;
      background: #ededed;
    }
    .orderList{
      width: 85%;
      margin: 10px auto;
      /deep/ .nut-checkbox{
        display: block;
        margin-top: 15px;
      }
      /deep/ .nut-checkbox.nut-checkbox-size-small input{
        position: relative;
        top:-2px
      }
      .money-class{
        float: right;
        font-size: 12px;
        color: red;
      }
    }
    .bk-class{
      margin: 20px auto;
      height: 100px;
      overflow:hidden;
      p{
        width: 96%;
      }
      .bk-p-class{
        margin: 10px auto;
      }
    }
    .d_phone{
      width: 85%;
      margin: 0 auto;
      position: relative;
      /deep/ .nut-textinput input{
        width: 100%;
        margin-top: 10px;
        border: 1px solid #999;
        color: #999;
        font-size: 14px;
      }
    }
    .input-code {
      position: absolute;
      right: 15px;
      top: 65%;
      height: 30px;
      .opt-a {
        display: block;
        width: 75px;
        height: 30px;
        line-height: 30px;
        background: #3eaef9;
        color: #fff;
        font-size: 12px;
        text-align: center;
      }
    }
    .footer{
      background: #F8F8F8;
      padding: 15px 0;
      display: flex;
      justify-content: center;
      position: fixed;
      bottom: 0;
      width: 100%;
      z-index: 23;
      button{
        border-radius: 10px;
        width: 52%;
        font-size: 14px;
        height: 45px;
        line-height: 45px;
        border: 1px solid #F94040 !important;
      }
    }
    .div_tips{
      width: 80%;
      margin: 10px auto;
      span{
        font-size: 14px;
        color: red;
      }
    }
  }
</style>

